import merge from 'lodash/merge';
import config from '../../config';
import fetch from '../fetch';
import logger from '../logger';
import RestEntityAPI from './restEntityAPI';

const GroupsAPI = () => {
  const parentAPI = RestEntityAPI({
    entityName: 'group',
    endpoint: () => `${config.apiUrl}/v1/groups`,
    searchEndpoint: `${config.apiUrl}/v1/group-search`,
  });

  const searchEntities = async (query, fetchOptions = {}) => {
    const { data } = await parentAPI.searchEntities(query, fetchOptions);
    const { content, ...pagination } = data;
    return { data: content, ...pagination };
  };

  const getEntities = async (query, parentIds, fetchOptions = {}) => {
    const { data } = await parentAPI.getEntities(query, parentIds, fetchOptions);
    const { content, ...pagination } = data;
    return { data: content, ...pagination };
  };

  const getGroupById = async ({ id, profileKey }) => {
    const getUrl = `${config.apiUrl}/v1/groups/${id}`;
    const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey, 'X-Check-Roles': true } : {};

    try {
      const { data } = await fetch(getUrl, {
        method: 'GET',
        headers,
      });
      return data;
    } catch (error) {
      logger.logDebug(`Failed to get Hiring Event ${id}`, error);
      throw error;
    }
  };

  return merge({}, { ...parentAPI }, { searchEntities, getEntities, getGroupById });
};

export default GroupsAPI;
